var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_99258",
    "data-name": "Group 99258",
    transform: "translate(-1401.995 -1422.995)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    transform: "translate(1401.995 1422.995)",
    fill: "#fff",
    opacity: 0.641
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    transform: "translate(1406.995 1427.995)",
    fill: "#fff",
    opacity: 0.629
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(1414.995 1435.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(1454.999 1453.741) rotate(90)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7,0,21.4,18.834H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.70095920562744 4.04849910736084 L 3.436647415161133 16.83369636535645 L 17.96527099609375 16.83369636535645 L 10.70095920562744 4.04849910736084 M 10.70095920562744 -3.814697265625e-06 L 21.40191841125488 18.83369636535645 L 0 18.83369636535645 L 10.70095920562744 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#d22524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.18e876a595672c1c19b676d75fb98948.svg";
export { ForwardRef as ReactComponent };